import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { LOAD_RETRY_TEXT } from "./constants";

interface StateCardProps {
  title: string;
  text: string;
  /** Adds ลองใหม่: the error state, as opposed to an empty one. */
  onRetry?: () => void;
}

/** The empty and the load-failed states of the รับจ่าย screens: a centred message on a card. */
export default function StateCard({ title, text, onRetry }: Readonly<StateCardProps>) {
  return (
    <Paper>
      <Stack alignItems="center" gap={1} sx={{ py: 6, textAlign: "center" }}>
        <Typography fontWeight={500} color={onRetry ? "text.primary" : "text.secondary"}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
        {onRetry && (
          <Button variant="outlined" onClick={onRetry} sx={{ mt: 1 }}>
            {LOAD_RETRY_TEXT}
          </Button>
        )}
      </Stack>
    </Paper>
  );
}
